import React, {useMemo} from 'react';
import {Controller, useForm} from 'react-hook-form';
import Grid from '@material-ui/core/Grid';
import {FormControl, FormControlLabel, Radio, RadioGroup, TextField} from "@mui/material";
import {TextFieldCounter} from "../../../../components/TextFieldCounter";

interface ActionProps {
    checked: boolean;
    placeholder: any;
    nameAction: any;
    descAction: any;
    value: any; // Substitua com o tipo correto, caso saiba os tipos exatos dos valores
    onChange: (id: string, name: string, value: any) => void;
    onCheck: (value: any) => void;
    id: string;
    disabled?: boolean;
}

const Action: React.FC<ActionProps> = ({
                                           checked,
                                           nameAction,
                                           descAction,
                                           value: valueProps,
                                           onChange,
                                           onCheck,
                                           id,
                                           disabled = false
                                       }) => {
    const {control: actionControl} = useForm({
        defaultValues: useMemo(() => {
            return valueProps;
        }, [valueProps]),
    });

    const handleChange = (id: any, descAction: string, event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>, onChangeInput: any) => {
        onChangeInput(event.target.value);
        onChange(id, descAction, event.target.value);

    };

    return (
        <Grid
            md={12}
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
        >
            <Grid item md={5}>

                <Controller
                    name={nameAction}
                    control={actionControl}
                    rules={{required: "Este campo é obrigatório"}}
                    render={({
                                 field: {value},
                                 fieldState: {error},
                             }) => (
                        <>
                            <TextField
                                disabled={true}
                                name={descAction}
                                fullWidth
                                value={value ?? ""}
                                onChange={(event: any) => onChange(valueProps[id], nameAction, event?.target?.value)}
                                inputProps={{maxLength: 140}}
                            />
                            <TextFieldCounter value={value} maxLength={140}/>
                            {error && (
                                <p style={{color: "red", marginTop: "8px"}}>
                                    {error.message}
                                </p>
                            )}
                        </>
                    )}
                />
            </Grid>
            <Grid item alignItems="center" md={1}>
                <FormControl>
                    <RadioGroup value={checked} onClick={() => onCheck(valueProps)}>
                        <FormControlLabel
                            value={checked}
                            control={<Radio checked={checked}/>}
                            label={''}/>
                    </RadioGroup>
                </FormControl>
            </Grid>
            <Grid item md={5}>
                <Controller
                    control={actionControl}
                    name={descAction}
                    rules={{required: "Este campo é obrigatório"}}
                    render={({
                                 field: {value, onChange: onChangeInput},
                                 fieldState: {error},
                             }) => (
                        <>
                            <TextField
                                disabled={disabled}
                                name={descAction}
                                fullWidth
                                value={value ?? ""}
                                onChange={(event) =>handleChange(valueProps[id], descAction, event, onChangeInput)}
                                inputProps={{maxLength: 140}}
                            />
                            <TextFieldCounter value={value} maxLength={140}/>
                            {error && (
                                <p style={{color: "red", marginTop: "8px"}}>
                                    {error.message}
                                </p>
                            )}
                        </>
                    )}
                />
            </Grid>
        </Grid>
    );
};

export default Action;